import React from 'react';
var Registers = function () {
    return <div className="Registers">Registers page</div>;
};
export default Registers;
